export class LokiMainController {
    public static $inject: string[] = [
        "$mdMedia",
        "$mdSidenav",
        "$rootScope",
        "$state",
        "hotkeys",
        "lokiFilterService",
        "sitesService"
    ];

    public layout;

    private currentStateName;

    constructor(
        public $mdMedia: ng.material.IMedia,
        private $mdSidenav: ng.material.ISidenavService,
        $rootScope: ng.IRootScopeService,
        $state: ng.ui.IStateService,
        private hotkeys,
        public lokiFilterService,
        public sitesService
    ) {
        this.currentStateName = $state.current.name;

        this.layout = {
            searchPlaceholder: "",
            hasFilters: false,
            hasSortMenu: false,
            areFiltersOpen: false
        };

        this._setLayout();

        $rootScope.$on("$stateChangeSuccess", (_, toState) => {
            this.currentStateName = toState.name;
            this._setLayout();
            this.lokiFilterService.resetAll();
        });
    }

    public $onDestroy() {
        this.hotkeys.del("mod+f");
    }

    public onSort(event) {
        this.lokiFilterService.sortParams = event.sortParams;
        this.search();
    }

    public openFilters() {
        if (this.layout.hasFilters) {
            this.layout.areFiltersOpen = true;
        }
    }

    public toggleSidenav() {
        this.$mdSidenav("lokiSidenav")
            .toggle();
    }

    public search() {
        this.lokiFilterService.search()
            .then(() => {
                this.layout.areFiltersOpen = false;
            });
    }

    private _setLayout() {
        this._setFiltersHotkeys();

        this.layout.hasFilters = true;
        this.layout.hasSortMenu = false;
        this.layout.areFiltersOpen = false;

        switch (this.currentStateName) {
            case "thor.loki.organizations":
                this.lokiFilterService.setContext("organizations");
                this.layout.searchPlaceholder = "Rechercher une étude";
                break;
            case "thor.loki.future-sales":
                this.lokiFilterService.setContext("future-sales");
                this.layout.searchPlaceholder = "Rechercher une vente future";

                if (this.lokiFilterService.futureSales.items.length === 0) {
                    this.openFilters();
                }
                break;
            case "thor.loki.past-sales":
                this.lokiFilterService.setContext("past-sales");
                this.layout.searchPlaceholder = "Rechercher une vente passée";

                if (this.lokiFilterService.pastSales.items.length === 0) {
                    this.openFilters();
                }
                break;
            case "thor.loki.past-items":
                this.lokiFilterService.setContext("past-items");
                this.layout.searchPlaceholder = "Rechercher un lot passé";
                this.layout.hasSortMenu = true;

                if (this.lokiFilterService.pastItems.items.length === 0) {
                    this.openFilters();
                }
                break;
            case "thor.loki.future-items":
                this.lokiFilterService.setContext("future-items");
                this.layout.searchPlaceholder = "Rechercher un lot futur";
                this.layout.hasSortMenu = true;

                if (this.lokiFilterService.futureItems.items.length === 0) {
                    this.openFilters();
                }
                break;
            default:
                this.layout.searchPlaceholder = "Rechercher";
                this.layout.hasFilters = false;
                break;
        }
    }

    private _setFiltersHotkeys() {
        this.hotkeys
            .add({
                combo: "mod+f",
                description: "Ouvrir la recherche",
                allowIn: ["INPUT", "SELECT", "TEXTAREA"],
                callback: e => {
                    e.preventDefault();
                    this._toggleFilters();

                    if (this.layout.hasFilters && this.layout.areFiltersOpen) {
                        document.getElementById("loki-raised-search-input").focus();
                    } else if (!this.layout.hasFilters) {
                        document.getElementById("loki-raised-search-input").focus();
                    }
                }
            });

        this.hotkeys
            .add({
                combo: "esc",
                description: "Fermer la recherche",
                allowIn: ["INPUT"],
                callback: e => {
                    e.preventDefault();
                    this.layout.areFiltersOpen = false;
                }
            });
    }

    private _toggleFilters() {
        if (this.layout.hasFilters) {
            this.layout.areFiltersOpen = !this.layout.areFiltersOpen;
        }
    }
}
